/**
 * @generated SignedSource<<09568aff1222bd48dd87dd37261b4203>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ProductHomeWithQuery$data = {
  readonly jira: {
    readonly issueByKey?: {
      readonly projectField: {
        readonly project: {
          readonly projectType: JiraProjectType | null;
        } | null;
      } | null;
    } | null;
    readonly jiraProjectByKey?: {
      readonly projectType: JiraProjectType | null;
    } | null;
  } | null;
  readonly " $fragmentType": "ProductHomeWithQuery";
};
export type ProductHomeWithQuery$key = {
  readonly " $data"?: ProductHomeWithQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductHomeWithQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = [
  {
    "kind": "ScalarField",
    "name": "projectType"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "issueKey"
    },
    {
      "kind": "RootArgument",
      "name": "projectKey"
    },
    {
      "kind": "RootArgument",
      "name": "shouldCheckProjectType"
    },
    {
      "kind": "RootArgument",
      "name": "shouldCheckProjectTypeForIssue"
    }
  ],
  "kind": "Fragment",
  "name": "ProductHomeWithQuery",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "shouldCheckProjectTypeForIssue",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Variable",
                  "name": "key",
                  "variableName": "issueKey"
                }
              ],
              "concreteType": "JiraIssue",
              "kind": "LinkedField",
              "name": "issueByKey",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraProjectField",
                  "kind": "LinkedField",
                  "name": "projectField",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraProject",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": (v1/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "condition": "shouldCheckProjectType",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Variable",
                  "name": "key",
                  "variableName": "projectKey"
                }
              ],
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jiraProjectByKey",
              "plural": false,
              "selections": (v1/*: any*/)
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "e010d0e7151a1ababcc9337fa39a44da";

export default node;
